module.exports = __webpack_public_path__ + "static/media/11(5).90e94f63.jpg";